import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle } from 'lucide-react';

interface CompleteProps {
  questionnaire_template: {
    id: number;
    title: string;
  };
  questionnaire_progress: {
    completed_at: string;
    total_questions_answered: number;
  };
}

export default function Complete({
  questionnaire_template,
  questionnaire_progress,
}: CompleteProps) {
  const completedDate = new Date(
    questionnaire_progress.completed_at
  ).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  return (
    <div className="min-h-screen py-8 bg-gray-50">
      <div className="max-w-2xl mx-auto px-4">
        <Card>
          <CardHeader className="text-center">
            <div className="mx-auto mb-4">
              <CheckCircle className="w-16 h-16 text-green-600" />
            </div>
            <CardTitle className="text-2xl">Congratulations! 🎉</CardTitle>
          </CardHeader>
          <CardContent className="text-center space-y-6">
            <p className="text-lg text-gray-700">
              You have successfully completed the{' '}
              <span className="font-semibold">
                {questionnaire_template.title}
              </span>
            </p>

            <div className="bg-gray-50 rounded-lg p-4 space-y-2">
              <p className="text-sm text-gray-600">
                <span className="font-medium">Completed on:</span>{' '}
                {completedDate}
              </p>
              <p className="text-sm text-gray-600">
                <span className="font-medium">Questions answered:</span>{' '}
                {questionnaire_progress.total_questions_answered}
              </p>
            </div>

            <div className="space-y-4 text-left">
              <h3 className="font-semibold text-gray-900 text-center">
                What's Next?
              </h3>
              <div className="space-y-3">
                <div className="flex items-start space-x-3">
                  <span className="text-green-600 mt-1">✓</span>
                  <p className="text-gray-600 text-sm">
                    You'll receive an email notification to confirm that your
                    responses have been recorded.
                  </p>
                </div>
                <div className="flex items-start space-x-3">
                  <span className="text-green-600 mt-1">✓</span>
                  <p className="text-gray-600 text-sm">
                    {questionnaire_template.title.includes('Mentor')
                      ? "We'll match you with a suitable mentee based on your responses and/or reach out for you to pick your mentee."
                      : "We'll match you with a suitable mentor based on your responses."}
                  </p>
                </div>
                <div className="flex items-start space-x-3">
                  <span className="text-green-600 mt-1">✓</span>
                  <p className="text-gray-600 text-sm">
                    You'll receive an email notification when matches are ready
                    in the next 1 month.
                  </p>
                </div>
              </div>
            </div>

            {/* <div className="pt-4 space-y-3">
              <Button
                onClick={() => router.visit('/dashboard')}
                className="w-full"
              >
                Go to Dashboard
              </Button>

              <Button
                variant="outline"
                onClick={() => router.visit('/profile')}
                className="w-full"
              >
                View My Profile
              </Button>
            </div> */}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
